module.exports = __webpack_public_path__ + "static/media/logoSmall.5c5b6a1e.png";